import { FC } from "react";
import { useTranslation } from "react-i18next";

interface TotalCount {
    currentCount?: number;
    allCount: number;
    title?: string;
}

const TotalCountComponent: FC<TotalCount> = (props: TotalCount) => {
    const { t } = useTranslation();
    return (
        <div className="total_counter_wrapper">
            <div style={{ color: "#586A84" }}>{props.title ? `${props.title}:` : t("employee.TotalCount")}</div>
            <div className="total_counter_div">
                <span className="total_counter_currentCount">
                    {props.currentCount ? props.currentCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}
                </span>
                <span>{t("word.of")}</span>
                <span className="total_counter_allCount">
                    {props.allCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0}
                </span>
            </div>
        </div>
    );
};

export default TotalCountComponent;
